module.exports = __webpack_public_path__ + "static/media/PC8.60d89863.png";